/* eslint-disable react/prop-types */
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type DummyPrivatePageEndpointSpecsFragment } from '../../../../../api/fragments/DummyPrivatePageEndpointSpecs';
import {
    CreateDummyPrivatePageEndpointDocument,
    type CreateDummyPrivatePageEndpointMutation,
    type CreateDummyPrivatePageEndpointMutationVariables,
} from '../../../../../api/mutations/createDummyPrivatePageEndpoint';
import {
    UpdateDummyPrivatePageEndpointDocument,
    type UpdateDummyPrivatePageEndpointMutation,
    type UpdateDummyPrivatePageEndpointMutationVariables,
} from '../../../../../api/mutations/updateDummyPrivatePageEndpoint';
import { type DummyPrivatePageSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import { type EndpointImplementation } from './types';

const implementation: EndpointImplementation<DummyPrivatePageEndpointSpecsFragment, DummyPrivatePageSettings> = {
    getTitle: t => t('routerDetails:endpoints.DummyPrivatePageEndpoint.title'),
    ViewPanelComponent: ({ endpoint }) => (
        <Descriptions size="small" bordered>
            <Descriptions.Item label="Body">{endpoint.body}</Descriptions.Item>
        </Descriptions>
    ),
    getIsPrivate: () => true,
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <>
                <InputField
                    {...t('routerDetails:endpoints.fields.pathname', { returnObjects: true })}
                    name="pathname"
                />
                <InputField {...t('routerDetails:endpoints.fields.privateBody', { returnObjects: true })} name="body" />
            </>
        );
    },
    getFormInitialValues: endpoint => ({
        pathname: endpoint.pathname,
        body: endpoint.body,
    }),
    submitCreation: (apolloClient, routerId, values) =>
        apolloClient.mutate<CreateDummyPrivatePageEndpointMutation, CreateDummyPrivatePageEndpointMutationVariables>({
            mutation: CreateDummyPrivatePageEndpointDocument,
            variables: { routerId, settings: values },
        }),
    submitUpdate: (apolloClient, routerId, endpointId, values) =>
        apolloClient.mutate<UpdateDummyPrivatePageEndpointMutation, UpdateDummyPrivatePageEndpointMutationVariables>({
            mutation: UpdateDummyPrivatePageEndpointDocument,
            variables: { routerId, endpointId, settings: values },
        }),
};

export default implementation;
